import { fmtDate } from './date';

/**
 * How an asset reads in every picker that lists one — Device sold on Log
 * Time, Linked asset on an expense:
 *
 *   "WD 1TB Passport — WDBYVG · S/N 123 · bought 09/02/2026"
 *
 * The purchase date tells apart identical drives bought on different days.
 * Whatever the asset doesn't have is left out.
 */
export function assetOptionLabel(a: {
  name: string;
  make_model: string | null;
  serial_number: string | null;
  purchase_date: number | null;
}): string {
  const extra = [
    a.make_model,
    a.serial_number && `S/N ${a.serial_number}`,
    a.purchase_date !== null && `bought ${fmtDate(a.purchase_date)}`,
  ].filter(Boolean).join(' · ');
  return extra ? `${a.name} — ${extra}` : a.name;
}
